const InsightShift = () => {
  return (
    <section className="bg-gradient-dark py-12 text-background lg:py-14">
      <div className="container-tight">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center text-xs font-medium uppercase tracking-[0.18em] text-signal-glow">
            The shift
          </span>
          <h2 className="mt-6 font-serif text-4xl leading-[1.1] tracking-tight text-background sm:text-5xl lg:text-6xl">
            The goal is not to do <em className="text-signal-glow">everything</em>.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-background/70">
            It's to start with the right thing without overcommitting upfront.
          </p>
        </div>
      </div>
    </section>
  );
};

export default InsightShift;
